const About = () => {
  return (
    <section className="py-20 bg-bg-70">
      <div className="w-[90%] max-w-6xl mx-auto">
        <div className="max-w-4xl">
          {/* Section Header */}
          <div className="mb-12">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-6 h-6 rounded-full bg-fg-60 flex items-center justify-center">
                <span className="text-bg-60 text-xs font-bold">@</span>
              </div>
              <h2 className="text-fg-40 text-lg font-semibold">About LeebAI</h2>
            </div>
          </div>

          {/* Main Content */}
          <div>
            <p className="text-fg-40 text-lg md:text-xl leading-relaxed font-semibold">
              <span className="font-semibold">
                LeebAI is an AI-powered chat solution designed to transform
                customer engagement through intelligent automation and
                data-driven insights.
              </span>{" "}
              Our platform enhances marketing strategies by facilitating
              seamless interactions, allowing businesses to connect with their
              audiences more effectively.{" "}
              <span className="text-fg-60">
                With LeebAI, you can elevate customer satisfaction, streamline
                communication, and drive growth in an increasingly digital
                landscape.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
